// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.custom-date-picker {
    width: 100%;
    max-width: 20vw;
    position: relative;
}

.custom-date-picker .text-label {
    border: none;
    padding: 2%;
}

.custom-date-picker .inputbox-container {
    display: flex;
    align-items: center;
    border: 1.5px solid black;
    border-radius: 4px;
}

.custom-date-picker .inputbox-container input{
    border: none;
    padding: 3%;
    width: 90%;
    color: black;
    text-align: center;
}

.custom-date-picker .inputbox-container input::placeholder{
    color: rgba(0, 0, 0, 0.5);
    text-align: center;
}

.custom-date-picker .modal {
    opacity: 1;
    display: flex;
    align-items: center;
    justify-content: center;
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background-color: rgba(0,0,0,.85);
    z-index: 999;
}

.custom-date-picker .modal [hidden] {
    display: none!important;
    visibility: none
}

.custom-date-picker .modal-content {
    width: 50%;
    height: 60%;
    background-color: white!important;
    padding: 2%;
}

.custom-date-picker .modal-content .dates-text {
    height: 7%;
    display: flex;
    justify-content: space-between;
}

.custom-date-picker .modal-content .dates-text .inputs {
    display: flex;
}

.custom-date-picker .modal-content .dates-text .inputs button {
    padding: 3%;
}

.custom-date-picker .modal-content .dates-text input {
    border-radius: 5px;
    text-align: center;
    border-top: 1px solid #cacbcd;
    border-bottom: 1px solid #cacbcd;
    border-left: 1px solid #cacbcd;
    border-right: 1px solid #cacbcd;
}

.custom-date-picker .modal-content .dates-text button {
    padding: 1%;
    text-align: center;
    align-items: center;
    justify-content: center;
    display: flex;
    border-radius: 5px;
    border: 1px silver;
}
.custom-date-picker .modal-content .dates-text button:hover {
    cursor: pointer;
}


.custom-date-picker  .input {
    width: 100%;
}

.custom-date-picker  .input input {
    text-align: center;
}
`, "",{"version":3,"sources":["webpack://./src/components/CustomDatePicker/CustomDatePicker.css"],"names":[],"mappings":"AAAA;IACI,WAAW;IACX,eAAe;IACf,kBAAkB;AACtB;;AAEA;IACI,YAAY;IACZ,WAAW;AACf;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,yBAAyB;IACzB,kBAAkB;AACtB;;AAEA;IACI,YAAY;IACZ,WAAW;IACX,UAAU;IACV,YAAY;IACZ,kBAAkB;AACtB;;AAEA;IACI,yBAAyB;IACzB,kBAAkB;AACtB;;AAEA;IACI,UAAU;IACV,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,eAAe;IACf,MAAM;IACN,OAAO;IACP,WAAW;IACX,YAAY;IACZ,iCAAiC;IACjC,YAAY;AAChB;;AAEA;IACI,uBAAuB;IACvB;AACJ;;AAEA;IACI,UAAU;IACV,WAAW;IACX,iCAAiC;IACjC,WAAW;AACf;;AAEA;IACI,UAAU;IACV,aAAa;IACb,8BAA8B;AAClC;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,WAAW;AACf;;AAEA;IACI,kBAAkB;IAClB,kBAAkB;IAClB,6BAA6B;IAC7B,gCAAgC;IAChC,8BAA8B;IAC9B,+BAA+B;AACnC;;AAEA;IACI,WAAW;IACX,kBAAkB;IAClB,mBAAmB;IACnB,uBAAuB;IACvB,aAAa;IACb,kBAAkB;IAClB,kBAAkB;AACtB;AACA;IACI,eAAe;AACnB;;;AAGA;IACI,WAAW;AACf;;AAEA;IACI,kBAAkB;AACtB","sourcesContent":[".custom-date-picker {\n    width: 100%;\n    max-width: 20vw;\n    position: relative;\n}\n\n.custom-date-picker .text-label {\n    border: none;\n    padding: 2%;\n}\n\n.custom-date-picker .inputbox-container {\n    display: flex;\n    align-items: center;\n    border: 1.5px solid black;\n    border-radius: 4px;\n}\n\n.custom-date-picker .inputbox-container input{\n    border: none;\n    padding: 3%;\n    width: 90%;\n    color: black;\n    text-align: center;\n}\n\n.custom-date-picker .inputbox-container input::placeholder{\n    color: rgba(0, 0, 0, 0.5);\n    text-align: center;\n}\n\n.custom-date-picker .modal {\n    opacity: 1;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    position: fixed;\n    top: 0;\n    left: 0;\n    width: 100%;\n    height: 100%;\n    background-color: rgba(0,0,0,.85);\n    z-index: 999;\n}\n\n.custom-date-picker .modal [hidden] {\n    display: none!important;\n    visibility: none\n}\n\n.custom-date-picker .modal-content {\n    width: 50%;\n    height: 60%;\n    background-color: white!important;\n    padding: 2%;\n}\n\n.custom-date-picker .modal-content .dates-text {\n    height: 7%;\n    display: flex;\n    justify-content: space-between;\n}\n\n.custom-date-picker .modal-content .dates-text .inputs {\n    display: flex;\n}\n\n.custom-date-picker .modal-content .dates-text .inputs button {\n    padding: 3%;\n}\n\n.custom-date-picker .modal-content .dates-text input {\n    border-radius: 5px;\n    text-align: center;\n    border-top: 1px solid #cacbcd;\n    border-bottom: 1px solid #cacbcd;\n    border-left: 1px solid #cacbcd;\n    border-right: 1px solid #cacbcd;\n}\n\n.custom-date-picker .modal-content .dates-text button {\n    padding: 1%;\n    text-align: center;\n    align-items: center;\n    justify-content: center;\n    display: flex;\n    border-radius: 5px;\n    border: 1px silver;\n}\n.custom-date-picker .modal-content .dates-text button:hover {\n    cursor: pointer;\n}\n\n\n.custom-date-picker  .input {\n    width: 100%;\n}\n\n.custom-date-picker  .input input {\n    text-align: center;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
